export default __webpack_public_path__ + "static/media/29.6769cae8.png";